import { inject, observer } from 'mobx-react';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { translate } from 'react-i18next';
import b from 'b_';
import EnvStore from '../../stores/EnvStore';
import BoolStore from '../../stores/helpers/BoolStore';
import Accordion from '../Accordion/Accordion';
import { FTBody } from '../Fuse/Text';
import { isFuse5Enabled } from '../../fuseFeatureFlag';
import OldFAQContent from './oldFAQContent';
import './FAQContent.new.css';

// see en.json "FAQ"
export const SECTIONS = {
    BROWSER_SUPPORT: 1,
    LANGUAGE_SUPPORT: 2,
    MOBILE_SUPPORT: 3,
    REGISTRATION_PROMPT: 4,
    BOOKMARK: 5,
    TAB: 6,
    WEBSITE_ISSUE: 7,
    SESSION_TIMEOUT: 8,
    WHAT_IS_UD: 9,
    DLP: 10,
    DOWNLOADS: 11,
    UPLOADS: 12,
    PHISHING: 13,
    MALWARE: 14,
    WHAT_IS_SAAS: 15,
};

const browserIsolationSections = [
    SECTIONS.BROWSER_SUPPORT,
    SECTIONS.LANGUAGE_SUPPORT,
    SECTIONS.REGISTRATION_PROMPT,
    SECTIONS.BOOKMARK,
    SECTIONS.TAB,
    SECTIONS.WEBSITE_ISSUE,
    SECTIONS.SESSION_TIMEOUT,
    SECTIONS.DLP,
    SECTIONS.DOWNLOADS,
    SECTIONS.UPLOADS,
    SECTIONS.PHISHING,
    SECTIONS.MALWARE,
];

const urlIsolationSections = [
    SECTIONS.WHAT_IS_UD,
    SECTIONS.DLP,
    SECTIONS.DOWNLOADS,
    SECTIONS.UPLOADS,
    SECTIONS.PHISHING,
    SECTIONS.MALWARE,
];

const saasIsolationSections = [
    SECTIONS.WHAT_IS_SAAS,
    SECTIONS.DLP,
    SECTIONS.DOWNLOADS,
    SECTIONS.UPLOADS,
    SECTIONS.PHISHING,
    SECTIONS.MALWARE,
];

const block = b.lock('Fuse5FAQ');

class NewFAQContent extends Component {
    static propTypes = {
        t: PropTypes.func.isRequired,
        env: EnvStore.PropType.isRequired,
        openSection: PropTypes.number,
    };

    constructor(props) {
        super(props);
        // Create flag stores for each possible FAQ section
        this.flagStores = {};
        Object.values(SECTIONS).forEach((sectionId) => {
            this.flagStores[sectionId] = new BoolStore(props.openSection === sectionId);
        });
    }

    render() {
        const { t, env, openSection } = this.props;
        let content = env.isUrlIsolation ? urlIsolationSections : browserIsolationSections;
        if (env.isSaasIsolation) {
            content = saasIsolationSections;
        }

        const accProps = (sectionId) => {
            const flagStore = this.flagStores[sectionId];
            return {
                flagStore,
                className: block('Accordion'),
                labelClassName: block('AccordionLabel'),
                usePlusIcon: true,
            };
        };

        return <div>
            <div className={block('Container')}>
                {content.map((i) => <div
                    key={i}
                    ref={(ref) => {
                        if (ref && i === openSection) {
                            setTimeout(() => ref.scrollIntoView(), 200);
                        }
                    }}
                >
                    <Accordion
                        {...accProps(i)}
                        label={t(`FAQ.q${i}`)}
                    >
                        <FTBody dangerouslySetInnerHTML={{ __html: t(`FAQ.a${i}`) }} />
                    </Accordion>
                </div>)}
            </div>
        </div>;
    }
}

const WrappedNewFAQContent = translate()(inject('env')(observer(NewFAQContent)));

const FAQContent = (props) => {
    return isFuse5Enabled() ? <WrappedNewFAQContent {...props} /> : <OldFAQContent {...props} />;
};

export default FAQContent;
